import { useState, useEffect } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Custom hook to check if the current user is in the admin group
 * @returns {Object} - { isAdmin: boolean, loading: boolean, error: string|null }
 */
export const useAdminCheck = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Get the current session to access the JWT tokens
        const session = await fetchAuthSession();
        
        // Check if we have access token
        if (session && session.tokens && session.tokens.accessToken) {
          const accessToken = session.tokens.accessToken;
          const groups = accessToken.payload['cognito:groups'] || [];
          
          setIsAdmin(groups.includes('admin'));
        } else {
          setIsAdmin(false);
        }
      } catch (err) {
        console.error('Error checking admin status:', err);
        setError('Failed to check admin status');
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdminStatus();
  }, []);

  return { isAdmin, loading, error };
};
